var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.45 13.632c1.252-.724 1.252-2.538 0-3.263L18.2 8.485 14.33 12l3.87 3.515 3.25-1.883Zm-4.336 2.513-3.673-3.337-7.905 7.184c.243 1.222 1.64 1.912 2.778 1.253l8.8-5.1ZM5.5 18.408V5.591l7.052 6.41L5.5 18.407Zm.036-14.4 7.905 7.185 3.673-3.337-8.8-5.1c-1.137-.66-2.535.03-2.778 1.252Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidFill);
export default __webpack_public_path__ + "static/media/android_fill.ff6c4f72ce173e82a073916a2787cdd4.svg";
export { ForwardRef as ReactComponent };